import { useState } from 'react';

import { useEffectOnce } from './useEffectOnce';

/**
 * Get a boolean that indicates if the component has mounted.
 */
export function useDidMount() {
	const [didMount, setDidMount] = useState(false);

	useEffectOnce(() => {
		setDidMount(true);
	});

	return didMount;
}
